import styles from '../../pages/UserSettings.module.scss'
import { Divider, Button } from '@mui/material'

const TabFooterButtons = ({cancelFunc, saveText = 'Save', saveFunc}) => {
    return (
        <>
            <Divider />
            <div className={styles['tab_buttons']}>
                <Button variant="outlined" size="medium" onClick={cancelFunc}>Cancel</Button>
                <Button variant="contained" size="medium" color="primary" onClick={saveFunc}>{saveText}</Button>
            </div>
        </>
    )
}
export default TabFooterButtons